import { render } from "./LinkageLoginProfileParent.vue?vue&type=template&id=5b9876a8&ts=true"
import script from "./LinkageLoginProfileParent.vue?vue&type=script&lang=ts"
export * from "./LinkageLoginProfileParent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__